import classNames from 'classnames';
import { SearchBar } from '@/components/organisms/search-bar/search-bar';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import styles from './travelportal-search-page-header.module.scss';

export interface TravelPortalSearchPageHeaderProps {
  /** Search settings for filters and search bar */
  searchSettings:
    | Content.Components['SearchSettingsDto']
    | Content.Components['TravelPortalSearchSettingsDto'];
}

const TravelPortalSearchPageHeader = ({
  searchSettings,
}: TravelPortalSearchPageHeaderProps) => {
  if (!searchSettings) {
    return null;
  }

  const basicSearchSettings =
    searchSettings as Content.Components['SearchSettingsDto'];

  const travelPortalSearchSettings =
    searchSettings.$type === 'TravelPortalSearchSettingsDto'
      ? (searchSettings as Content.Components['TravelPortalSearchSettingsDto'])
      : undefined;

  return (
    <section className={classNames(styles.component)}>
      <Container>
        <Row className={styles.row}>
          <Column width={{ desktop: 12 }}>
            <div className={styles.searchBarContainer}>
              <SearchBar
                autoSearch
                className={styles.searchBar}
                compact
                searchSettings={basicSearchSettings}
                shouldNavigate
                travelPortalSearchSettings={travelPortalSearchSettings}
              />
            </div>
          </Column>
        </Row>
      </Container>
    </section>
  );
};

TravelPortalSearchPageHeader.displayName = 'TravelPortalSearchPageHeader';

export default TravelPortalSearchPageHeader;
